export { default } from './training-zone';